import axios from "axios";
import { API } from "@/lib/api";

const KEY = "am_ins_token";
export const getInsToken = () => localStorage.getItem(KEY);
export const setInsToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

export const insApi = axios.create({ baseURL: `${API}/insurer`, withCredentials: true });
insApi.interceptors.request.use((config) => {
  const t = getInsToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const insFileUrl = (id) => `${API}/insurer/files/${id}?auth=${getInsToken() || ""}`;

export const INS_STATUSES = [
  ["submitted", "Submitted"], ["under_review", "Under Review"], ["assessment_scheduled", "Assessment Scheduled"],
  ["quote_ready", "Quote Ready"], ["quote_accepted", "Quote Accepted"], ["quote_declined", "Quote Declined"],
  ["job_authorised", "Job Authorised"], ["completed", "Completed"],
];
export const INS_STATUS_LABEL = Object.fromEntries(INS_STATUSES);

export const INCIDENT_TYPES = [
  ["accident_damage", "Accident damage"], ["theft_recovery", "Theft recovery"], ["fire_damage", "Fire damage"],
  ["flood_damage", "Flood damage"], ["other", "Other"],
];
export const DAMAGE_AREAS = [
  ["front", "Front"], ["rear", "Rear"], ["left_side", "Left side"], ["right_side", "Right side"], ["roof", "Roof"],
  ["undercarriage", "Undercarriage"], ["interior", "Interior"], ["engine_bay", "Engine bay"], ["other", "Other"],
];
export const SEVERITIES = [
  ["minor", "Minor"], ["moderate", "Moderate"], ["severe", "Severe"], ["write_off_assessment", "Write-off assessment required"],
];
export const QUOTE_CATS = [
  ["labour", "Labour"], ["parts", "Parts"], ["materials", "Materials"], ["paint", "Paint"],
  ["consumables", "Consumables"], ["other", "Additional charges"],
];
export const label = (list, key) => (list.find(([k]) => k === key) || [key, key])[1];
export const harareToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Africa/Harare" });

const TONE = {
  submitted: "bg-[#020165]/10 text-[#020165]", under_review: "bg-[#020165]/10 text-[#020165]",
  assessment_scheduled: "bg-amber-100 text-amber-800", quote_ready: "bg-[#F86900]/15 text-[#B54708]",
  quote_accepted: "bg-emerald-100 text-emerald-800", quote_declined: "bg-red-100 text-red-700",
  job_authorised: "bg-emerald-100 text-emerald-800", completed: "bg-slate-200 text-slate-700",
};
export const insTone = (s) => TONE[s] || "bg-slate-100 text-slate-700";
